import React, { useState, Fragment } from 'react';
import { Dialog, Box, Typography, ListItem, IconButton, CircularProgress, DialogActions, DialogContent, Button, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Close } from '@material-ui/icons';
import icAttachment from '../../assets/icons/ic_attachment.png';
import icAttachSelected from '../../assets/icons/ic_attach_selected.png';
import { useTranslate, useDataProvider } from 'react-admin';
import SelectBox from '../../CustomizedUIs/CustomSelectBox';
import CustomTextField from '../../users/CustomTextField';
import CustomPoper from '../../CustomizedUIs/CustomPoper';
import { usePopupState, bindToggle } from 'material-ui-popup-state/hooks';
import CustomPopoverArrow from '../../CustomizedUIs/CustomPopoverArrow';
import UploadFilesPopup from '../../file-management/upload-files-popup';
import AttachmentItem from '../../message/table-attachment-item';
import { baseAuthUrl } from '../../authProvider';
import Loading from '../../common/loading-page';
import TextButton from '../../CustomizedUIs/TextButton';
import CloseButton from '../../CustomizedUIs/CloseButton';

const useStyles = makeStyles(theme => ({
    dialogCloseBtn: {
        backgroundColor: theme.palette.common.white,
        marginLeft: 10
    },
    dialogPaper: {
        minHeight: '90vh',
        maxHeight: '90vh',
        maxWidth: '650px',
        backgroundColor: theme.palette.background.default
    },
    dialogActions: {
        paddingLeft: 32,
        paddingRight: 35,
        bottom: 0,
        right: 0,
    },

    btnSend: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: ' 11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: ' 0.44px',
        color: '#ffffff',
    },
    send: {
        marginRight: '30px',
        width: '138px',
        height: '36px',
    },
    title: {
        fontFamily: "UniviaPro-Medium",
        fontSize: "18px",
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
        color: "#4f5064",
        paddingBottom: "30px",
        marginTop: -10
    },
    textSelectBox: {
        height: '24px',
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.85,
        letterSpacing: ' 0.13px',
        color: '#88898c',
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: theme.palette.grey['200'],
        borderRightColor: theme.palette.grey['200'],
    },
    inputMulti: {
        width: '525px',
        borderRadius: '2px'
    },
    number: {
        "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
            "-webkit-appearance": "none",
            margin: 0
        },
        " & input[type=number] ": {
            "-moz-appearance": "textfield",
        }
    },
    titleParameter: {
        fontFamily: "UniviaPro-Medium",
        fontSize: "11px",
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
        color: "#4f5064",
    },
}));

const issueData = [
    { id: 1, name: "TV issue" },
    { id: 2, name: "Admin bug" },
    { id: 3, name: "Admin rights/permission" },
    { id: 4, name: "Error" },
    { id: 5, name: "User support" },
]

function DialogSupport({ open, onClose }) {
    const classes = useStyles();
    const translate = useTranslate();
    const dataProvider = useDataProvider();

    const [openPoper, setOpenPopper] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [openIssue, setOpenIssue] = useState(false);
    const [loading, setLoading] = useState(false);
    const [issue, setIssue] = useState('');
    const [categories, setCategories] = useState([]);
    const [isAttachOpen, setAttachOpen] = useState(false);
    const [emails, setEmails] = useState('');
    const popupState = usePopupState({ variant: 'popper', popupId: 'attachments' });
    const [textValue, setTextValue] = React.useState({
        subject: '',
        description: '',
        phoneNumber: '',
        email: ''
    });
    const [error, setError] = useState({
        subject: {
            isError: false,
            message: ""
        },
        description: {
            isError: false,
            message: ""
        },
        phoneNumber: {
            isError: false,
            message: ""
        },
        email: {
            isError: false,
            message: ""
        }
    });

    const handleClickOpenIssue = () => {
        setOpenIssue(!openIssue)
    }

    const onChangeSelectIssue = (item) => {
        setIssue(item.name)
        setOpenIssue(false)
    }

    const textOnChange = prop => (e) => {
        setTextValue({
            ...textValue, [prop]: e.target.value
        })
        validate(prop, e.target.value)
    }

    const validate = (prop, value) => {
        switch (prop) {
            case 'email':
                if (value.length === 0)
                    setError({
                        ...error, [prop]: value.length === 0 ? {
                            isError: true, message: translate('pos.messages.required')
                        } : {
                                isError: false, message: ''
                            }
                    })
                else {
                    setError({
                        ...error, [prop]: (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/).test(value) === false ? {
                            isError: true, message: translate(`pos.auth.errorEmail`)
                        } : {
                                isError: false, message: ''
                            }
                    })
                }
                break;
            default:
                if (value.length === 0)
                    setError({
                        ...error, [prop]: value.length === 0 ? {
                            isError: true, message: translate('pos.messages.required')
                        } : {
                                isError: false, message: ''
                            }
                    })
                else {
                    setError({
                        ...error, [prop]: {
                            isError: false, message: ''
                        }
                    })
                }
                break
        }
    }

    const handleClickOpenPoper = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenPopper(true);
    };

    const handleClosePoper = () => {
        setOpenPopper(false);
    };

    const disableSendButton = () => {
        if ((issue && textValue.subject && textValue.description && textValue.email && textValue.phoneNumber) === '') return true;
        if (error.email.message !== "" && error.email.isError === true) return true;
        return false;
    }

    const getCategory = (newCategories) => {
        if (newCategories) {
            setCategories([...categories, ...newCategories]);
        }
    }

    const renameCategory = (category) => {
        if (category) {
            let newCategories = categories.map(item => {
                if (item.id === category.id) {
                    item = category;
                }
                return item;
            })
            setCategories(newCategories);
        }
    }

    const onUploadFilesSuccess = (categories) => {
        setAttachOpen(false);
        getCategory(categories);
        popupState.close();
    }

    const onDeleteOne = (id) => {
        const newCategories = categories.filter(item => item.id !== id);
        setCategories(newCategories);
        dataProvider('DELETE', 'category', { id }).then((data) => {
        }).catch(error => {
            console.log('onDeleteOne error:', error);
        });
    }

    const removeCategories = () => {
        categories.forEach(item => {
            dataProvider('DELETE', 'category', { id: item.id }).then((data) => {
            }).catch(error => {
                console.log('onDeleteOne error:', error);
            });
        })
    }

    const clearDialog = () => {
        setTextValue({
            subject: '',
            description: '',
            phoneNumber: '',
            email: ''
        })
        setIssue('')
        setCategories([])
        setError({
            subject: {
                isError: false,
                message: ""
            },
            description: {
                isError: false,
                message: ""
            },
            phoneNumber: {
                isError: false,
                message: ""
            },
            email: {
                isError: false,
                message: ""
            }
        })
    }

    const handleClose = () => {
        removeCategories()
        clearDialog()
        onClose();
    }

    const handleSend = () => {
        setLoading(true)
        let attachmentArray = []
        for (let i = 0; i < categories.length; i++) {
            let attachment = {
                path: '',
                filename: ''
            }
            attachment.path = `${baseAuthUrl}/media/${categories[i].fd}`
            attachment.filename = categories[i].name
            attachmentArray.push(attachment)
        }

        dataProvider('CREATE', 'support', {
            data: {
                subject: textValue.subject,
                issue: issue,
                description: textValue.description,
                phoneNumber: textValue.phoneNumber,
                email: textValue.email,
                photo: attachmentArray,
                emailReceiver: emails
            }
        }).then(({ data }) => {
            setLoading(false)
            clearDialog()
            onClose('Success')
            console.log('data', data)
        }).catch(error => console.error('Cannot send:', error));
    }

    const getUserData = () => {
        setLoading(true)
        const userData = JSON.parse(localStorage.getItem('userData'))
        setTextValue({
            subject: '',
            description: '',
            email: userData.user.email,
            phoneNumber: userData.user.phoneNumber
        });
        dataProvider('GET_LIST', "settings", {
            filter: {
                cluster: null,
                room: null,
                name: 'Support message e-mail'
            },
            pagination: {},
            sort: {},
        }).then(({ data }) => {
            const listEmail = JSON.parse(data[0].value)
            let emailString = ""
            listEmail.forEach(item => {
                if (emailString === "")
                    emailString = item
                else
                    emailString += `,${item}`
            })
            setEmails(emailString)
            setLoading(false)
        }).catch(error => {
            setLoading(false)
        });
    }

    const onEnter = () => {
        getUserData();
    }

    return (
        <Dialog open={open} onEnter={onEnter} onClose={handleClose} aria-labelledby="form-dialog-title" scroll='paper' classes={{ paper: classes.dialogPaper }} fullWidth={true} disableEnforceFocus disableBackdropClick>
            <Box mx={5} mt={3}>
                <Box display='flex' justifyContent='flex-end' alignItems='center' mr={2} mt={1}>
                    <Typography variant='subtitle2'>{translate(`pos.user.close`)}</Typography>
                    <CloseButton onClick={handleClose}/>
                </Box>
                <Typography className={classes.title}>{translate(`pos.support.title`)}</Typography>
            </Box>
            <DialogContent style={{ padding: '8px 40px' }}>
                <Fragment>
                    {loading &&
                        <Loading />
                    }
                    <Box mt={4} mx={2.5}>
                        <CustomTextField
                            onBlur={() => {
                                validate('subject', textValue.subject)
                            }}
                            required
                            id="filled-basic"
                            label={translate(`pos.messages.subject`)}
                            value={textValue.subject}
                            onChange={textOnChange('subject')}
                            error={error.subject.message !== "" && error.subject.isError}
                            helperText={error.subject.message}
                            style={{ width: 525 }}
                            endDom={<CustomPoper
                                open={openPoper}
                                anchorEl={anchorEl}
                                handleClick={handleClickOpenPoper}
                                handleClose={handleClosePoper}
                                title={translate(`pos.messages.subject`)}
                                content={translate(`pos.support.subjectContent`)}
                                icon={<b>?</b>}
                            />}
                        />
                    </Box>
                    <Box mt={4} mx={2.5} style={{ width: 525 }}>
                        <SelectBox
                            required
                            label={translate('pos.support.issue')}
                            value={issue}
                            open={openIssue}
                            handleClick={handleClickOpenIssue}
                        >
                            <Box >
                                {
                                    issueData.map(item => (
                                        <ListItem key={item.id} style={{ padding: '8px' }} onClick={() => onChangeSelectIssue(item)} button >
                                            <Typography className={classes.textSelectBox}>{item.name}</Typography>
                                        </ListItem>
                                    ))
                                }
                            </Box>
                        </SelectBox>
                    </Box>
                    <Box mt={4} mx={2.5}>
                        <CustomTextField
                            onBlur={() => {
                                validate('description', textValue.description)
                            }}
                            className={classes.inputMulti}
                            id="textfield-message"
                            multiline
                            rows={4}
                            value={textValue.description}
                            onChange={textOnChange('description')}
                            placeholder={`${translate(`pos.support.description`)} *`}
                            error={error.description.message !== "" && error.description.isError}
                            helperText={error.description.message}
                        />
                    </Box>
                    <Box mt={4} mx={2.5}>
                        <CustomTextField
                            required
                            className={classes.number}
                            id="filled-basic"
                            type='number'
                            label={translate(`pos.user.phonenumber`)}
                            value={textValue.phoneNumber}
                            onChange={textOnChange('phoneNumber')}
                            error={error.phoneNumber.message !== "" && error.phoneNumber.isError}
                            helperText={error.phoneNumber.message}
                            style={{ width: 525 }}
                            endDom={<CustomPoper
                                open={openPoper}
                                anchorEl={anchorEl}
                                handleClick={handleClickOpenPoper}
                                handleClose={handleClosePoper}
                                title={translate(`pos.user.phonenumber`)}
                                content={translate(`pos.support.phoneNumber`)}
                                icon={<b>?</b>}
                            />}
                        />
                    </Box>
                    <Box mt={4} mx={2.5}>
                        <CustomTextField
                            required
                            id="filled-basic"
                            label={translate(`pos.user.email`)}
                            value={textValue.email}
                            onChange={textOnChange('email')}
                            error={error.email.message !== "" && error.email.isError}
                            helperText={error.email.message}
                            style={{ width: 525 }}
                            endDom={<CustomPoper
                                open={openPoper}
                                anchorEl={anchorEl}
                                handleClick={handleClickOpenPoper}
                                handleClose={handleClosePoper}
                                title={translate(`pos.user.email`)}
                                content={translate(`pos.auth.email`)}
                                icon={<b>?</b>}
                            />}
                        />
                    </Box>
                    <Box mt={3} mx={2.5} display='flex' alignItems='center'>
                        <Grid
                            container
                            direction="row"
                            justify="space-between"
                            alignItems="flex-start">
                            <Grid item >
                                <Box display='flex' borderRadius={4} alignItems='center'>
                                    <IconButton
                                        variant="outlined"
                                        color='primary'
                                        style={{ marginRight: '10px', padding: 'unset' }}
                                        {...bindToggle(popupState)}
                                    >
                                        {
                                            isAttachOpen ?
                                                <img src={icAttachSelected} width={27} height={27} /> : <img src={icAttachment} height={27} width={27} />
                                        }
                                    </IconButton>
                                    <CustomPopoverArrow
                                        zIndex={1500}
                                        popupState={popupState}
                                        placement='left-end'
                                    >
                                        <UploadFilesPopup
                                            onUploadFilesSuccess={onUploadFilesSuccess}
                                            parentId={8}        // default attachments folder id
                                            close={() => {
                                                setAttachOpen(false);
                                                popupState.close();
                                            }}
                                            getCategory={getCategory}
                                            acttachmentStyle={{
                                                maxHeight: 260,
                                                overflow: 'auto'
                                            }}
                                        />
                                    </CustomPopoverArrow>
                                    <Typography className={classes.titleParameter} >{translate('pos.support.addAttachments')}</Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box mt={2} mx={2.5} style={{ maxHeight: "60vh", overflow: 'auto', }}>
                        {
                            categories.map(item =>
                                <AttachmentItem
                                    renameCategory={renameCategory}
                                    item={item}
                                    key={item.id + ''}
                                    onDeleteOne={onDeleteOne}
                                    handleDownload={() => { }}
                                    isDownload={false}
                                />
                            )
                        }
                    </Box>
                </Fragment>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <TextButton mr={2} style={{ marginTop: "1em" }} onClick={handleClose} />
                <Button
                    disabled={disableSendButton()}
                    variant="contained"
                    className={classes.send}
                    size="large"
                    color="primary"
                    onClick={handleSend}
                >
                    {loading ? (
                        <CircularProgress
                            size={25}
                            thickness={2}
                            color='inherit'
                        />
                    ) :
                        <Typography className={classes.btnSend}>{translate('resources.room.send')}</Typography>
                    }
                </Button>
            </DialogActions>
        </Dialog >
    );
}

export default DialogSupport;
